import { cloneDeep } from 'lodash'

import { SENDINGS_INCOMING_FILTER, dateFilter } from '@/utils'

import render from './render'

export default {
  name: 'SendingsIncomingFilter',

  mixins: [ dateFilter ],

  methods: {
    getDefaultFilter() {
      return cloneDeep(SENDINGS_INCOMING_FILTER)
    },

    clearFilter() {
      this.proxy = cloneDeep(this._inputFilter(this.getDefaultFilter()))
    }
  },

  render
}
